module.exports = __webpack_public_path__ + "img/logo.98e8e9ad.png";